import { clsx } from 'clsx'
import { ChangeEvent, ReactNode } from 'react'
import css from './Checkbox.module.scss'

type Props<Data> = {
  checked?: boolean
  children: ReactNode
  className?: string
  data?: Data
  disabled?: boolean
  error?: boolean
  onChange?(checked: boolean, data: Data): void
}

export const Checkbox = <Data = void, >(props: Props<Data>) => {
  const { checked, children, data, disabled, error, onChange } = props
  const className = clsx(props.className, css.checkbox, checked && css.checked, error && css.error)

  const onChangeCheckbox = (event: ChangeEvent<HTMLInputElement>) => {
    const checked = event.target.checked
    if (onChange) onChange(checked, data!)
  }

  return <label className={className}>
    <div className={css.check}>
      <input type="checkbox" checked={checked} disabled={disabled} onChange={onChangeCheckbox} />
    </div>
    <span className={css.text}>{children}</span>
  </label>
}
